// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__TolB0","productName":"Table_productName__2twjb"};